import { createStore } from 'vuex';
import hakandil from './modules/hakandil';
import auth from './modules/auth';
import quizSession from './modules/quiz/session';
import quizList from './modules/quiz/list';

import newHakandil from './modules/new/hakandil';
import newQuizSession from './modules/new/quiz/session';
import newQuizList from './modules/new/quiz/list';

export default createStore({
  modules: {
    auth,
    quizList,
    quizSession,
    app: hakandil,
    newApp: newHakandil,
    newQuizList,
    newQuizSession,
  },
  strict: process.env.VUE_APP_DEBUG,
});
